import React from "react";
import { Link } from "react-router-dom";
import styles from "./PublicInfoPage.module.scss";

const policySections = [
	{
		title: "Information we collect",
		items: [
			"Name, email address and mobile phone number",
			"Child name, class, school id and relationship to the student",
			"Attendance, reports, notifications and other school-managed student data",
			"Device, usage and security information needed to operate the service",
		],
	},
	{
		title: "How we use information",
		items: [
			"Facilitate communication between schools and parents",
			"Provide student updates, announcements and notifications",
			"Improve app reliability, support and product experience",
			"Respond to inquiries and provide customer support",
		],
	},
	{
		title: "Security and retention",
		items: [
			"We do not sell personal information.",
			"We use secure authentication, limited access and encrypted storage where appropriate.",
			"We retain personal information only as long as needed for services, legal compliance and school records.",
			"No digital transmission or storage method is completely risk free.",
		],
	},
];

const PrivacyPolicy = () => {
	return (
		<main className={styles.page}>
			<section className={styles.hero}>
				<div>
					<p className={styles.eyebrow}>Stepswatch</p>
					<h1>Privacy Policy</h1>
					<p>
						We value your trust and protect information shared through our web
						and mobile applications for schools, staff and parents.
					</p>
				</div>
				<Link className={styles.backButton} to="/login">
					<span className="material-icons">arrow_back</span>
					Back to login
				</Link>
			</section>

			<section className={styles.contentGrid}>
				<article className={styles.mainCard}>
					<div className={styles.sectionHeader}>
						<span className="material-icons">verified_user</span>
						<div>
							<h2>Privacy at a glance</h2>
							<p>
								Stepswatch connects schools and parents to improve communication,
								child engagement and operational visibility.
							</p>
						</div>
					</div>

					<div className={styles.sectionStack}>
						{policySections.map((section, index) => (
							<section className={styles.policySection} key={section.title}>
								<span className={styles.sectionNumber}>{index + 1}</span>
								<div>
									<h3>{section.title}</h3>
									<ul>
										{section.items.map((item) => (
											<li key={item}>{item}</li>
										))}
									</ul>
								</div>
							</section>
						))}
					</div>
				</article>

				<aside className={styles.sidePanel}>
					<div className={styles.infoCard}>
						<span className="material-icons">child_care</span>
						<h2>Children's privacy</h2>
						<p>
							Child-related data is provided and managed by the school in
							accordance with applicable privacy laws and school policies.
						</p>
					</div>
					<div className={styles.infoCard}>
						<span className="material-icons">update</span>
						<h2>Policy updates</h2>
						<p>
							We may update this policy from time to time and will notify users
							through the app or by email where appropriate.
						</p>
					</div>
					<div className={styles.contactCard}>
						<span>Contact</span>
						<strong>Stepswatch Privacy Team</strong>
						<a href="mailto:contact@stepswatch.com">contact@stepswatch.com</a>
					</div>
				</aside>
			</section>
		</main>
	);
};

export default PrivacyPolicy;
